export default __webpack_public_path__ + "static/media/portfolio_free.3a9609fa.png";